import { tokens } from '@gripp/shared-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

export const ViewAllSectionHeader: React.FC<{
  title: string;
  onPress: () => void;
  disabled?: boolean;
}> = ({ title, onPress, disabled }) => {
  const { t } = useTranslation();

  return (
    <View style={styles.listHeaderContainerCropCircle}>
      <Text style={styles.sectionTitleCropCircle}>{title}</Text>
      <Pressable onPress={onPress} disabled={disabled}>
        <Text style={[styles.viewAllButtonLabelCropCircle]}>
          {t(`activity.header.viewAll`)}
        </Text>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  listHeaderContainerCropCircle: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: tokens.spacing.md,
    height: 20,
  },
  sectionTitleCropCircle: {
    textAlignVertical: 'top',
    ...tokens.typography.body.mediumEmphasised,
    color: tokens.colors.neutral[800],
  },
  viewAllButtonLabelCropCircle: {
    ...tokens.typography.body.small,
    color: tokens.colors.slate[400],
  },
});
